// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { RateType } from './rate-type';
import { RateValue } from './rate-value';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Rate extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  rateId!: number;
  createdBy!: string;
  createdDate!: Date;
  fromDate!: Date;
  rateTypeId!: number;
  toDate!: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  rateType!: RateType;
  rateValues!: RateValue[];
}

